import { CorePermissions } from "app/appPermissions";
import { MprcContainer, MprcFormSubHeader } from "components";
import { MprcSwitch } from "components/MprcSwitch";
import { TagUsage } from "generated/CoreApi_v1";
import { useSession } from "providers/SessionProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuestionContext } from "views/assessment/questionBank/Home/EditQuestion/EditQuestion";
import { EditQuestionAvailableQuestion } from "views/assessment/questionBank/Home/EditQuestion/EditQuestionAvailableQuestion";
import { TagAutoComplete } from "views/foundation/tag/components/TagAutoComplete";

/////////////////////////////////////////////////////////////////////////////////

interface IPros {
    onError: (error: any) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const EditQuestionClassification: React.FC<IPros> = (props) => {

    const { permissionExplorer } = useSession();
    const { t } = useTranslation("assessment");

    const { onError } = props;
    const { viewData, readonly, handleUpdateRecord } = useQuestionContext();

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {
                viewData.exclusiveAssessmentId == null
                    ?
                    <>
                        <MprcContainer>
                            <MprcFormSubHeader
                                title={t("Question.Edit.Classification.AvailabilityTitle")}
                            />
                            <MprcSwitch
                                label={t("Question.Edit.Classification.IsBlockedLabel")}
                                checked={viewData.isBlocked ?? false}
                                disabled={readonly}
                                onChange={(e) => handleUpdateRecord("isBlocked", e.target.checked)}
                            />
                        </MprcContainer>
                    </>
                    : permissionExplorer.hasOne([CorePermissions.AssessmentManageQuestionBank])
                        ? <EditQuestionAvailableQuestion onError={onError} />
                        : null
            }
            <MprcContainer>
                <MprcFormSubHeader
                    title={t("Question.Edit.PointOthers.TagsLabel")}
                />
                <TagAutoComplete
                    multiSelect
                    selectedItems={viewData.tags}
                    usage={TagUsage.Learning}
                    disabled={readonly}
                    onChange={(items) => handleUpdateRecord("tags", items)}
                    canCreate
                    onError={error => onError(error)}
                />
            </MprcContainer>
        </>
    );
};
